import logo from "./logo.svg";
import "sanitize.css/sanitize.css";
import "./App.css";
import React, { useEffect } from "react";
import {
  Route,
  Switch,
  BrowserRouter,
  Redirect,
  useLocation,
} from "react-router-dom";
import { PrivateRoute } from "./ProtectedRoute";
import Home from "./HomeComponent";
import PhoneNumber from "./PhoneNumber";
import LoginProvider from "./context/LoginContext";
import LanguageProvider from "./context/localization/languageState";
import TdbOpen from "./screens/tdb-open";
import { Router } from "@material-ui/icons";
import OTP from "./otpModal/otp";
import Password from "./password/password";
import TermsConditions from "./screens/terms/terms";
import PrivacyPolicy from "./screens/privacy/privacy";
import PosMachineId from "./screens/posMachineId";
import PosCustomerSearch from "./screens/pocUniqueCustomer/PosCustomerSearch";
import PosUniqueCode from "./screens/pocUniqueCustomer/PosUniqueCode";
import PosPayment from "./screens/pocUniqueCustomer/PosPayment";
import PaymentProcess from "./screens/pocUniqueCustomer/paymentProcess";
import PosTransactionStatus from "./screens/pocUniqueCustomer/PosTransactionStatus";
import OffilneFinanceSearch from "./screens/offlineFinance/OffilneFinanceSearch";
import InitiateLoan from "./screens/offlineFinance/InitiateLoan";
import LoanSuccess from "./screens/offlineFinance/loanSuccess";
import CustomerSearch from "./screens/customerSearch";
import CustomerDetails from "./screens/customerSearch/CustomerDetails";
import ManageOrders from "./screens/manageOrders";
import CreateAccount from "./screens/createAccount";
import CreateOrder from "./screens/createOrder";
import SearchExchange from "./screens/scooterExchange/searchExchange";
import ScooterExchangeData from "./screens/scooterExchange/scooterExchangeData";
import ScooterExchangeEdit from "./screens/scooterExchange/scooterExchangeEdit";
import UploadScooter from "./screens/scooterExchange/uploadScooter";
import axios from "axios";
import CustomerContextProvider from "./context/CustomerContext";
import ApplyCouponSearch from "./screens/couponApply/ApplyCouponSearch"
import ApplyCouponDetails from "./screens/couponApply/ApplyCouponDetails"
import OfflinePayment from "./screens/offlinePayment/OfflinePayment";
import SuccessfulPayment from "./screens/offlinePayment/SuccessfulPayment";
import CodeOfflinePayment from "./screens/offlinePayment/CodeOfflinePayment";
import ScooterExchangeVerify from "./screens/scooterExchange/scooterExchangeVerify";
import CheckScooterEligibility from "./screens/checkEligibility/checkScooterEligibility";
import CheckScooterStatus from "./screens/checkEligibility/checkScooterStatus";
import CashType from "./screens/offlinePayment/CashType";
import OfflineScooterExchangeEdit from "./screens/scooterExchange/offlineScooterExchangeEdit";
import CashTypePayment from "./screens/offlinePayment/CashTypePayment";



function App() {
  useEffect(() => {
    axios
      .get("/env_const")
      .then((res) => {
        console.log("res", res);
        localStorage.setItem("env_const", JSON.stringify(res.data));
      })
      .catch((err) => {
        console.log("err", err);
      });
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <LoginProvider>
          <CustomerContextProvider>
            <LanguageProvider>
              <Switch>
                <PrivateRoute
                  exact
                  path="/"
                  component={(props) => <TdbOpen />}
                />
                <PrivateRoute
                  exact
                  path="/manage-orders"
                  component={(props) => <ManageOrders />}
                />
                <PrivateRoute
                  exact
                  path="/create-account"
                  component={(props) => <CreateAccount />}
                />
                <PrivateRoute
                  exact
                  path="/create-order"
                  component={(props) => <CreateOrder />}
                />
                <PrivateRoute
                  exact
                  path="/booking-list"
                  component={(props) => <TdbOpen />}
                />
                {/* <PrivateRoute
                  exact
                  path="/pos-machineId"
                  component={(props) => <PosMachineId />}
                /> */}
                <PrivateRoute
                  exact
                  path="/customer-search"
                  component={(props) => <CustomerSearch />}
                />
                <PrivateRoute
                  exact
                  path="/customer-details"
                  component={(props) => <CustomerDetails />}
                />
                {/* <PrivateRoute
                  exact
                  path="/pos-customer-search"
                  component={(props) => <PosCustomerSearch />}
                /> */}
                {/* <PrivateRoute
                  exact
                  path="/pos-unique-code"
                  component={(props) => <PosUniqueCode />}
                /> */}
                {/* <PrivateRoute
                  exact
                  path="/pos-proceed-payment"
                  component={(props) => <PosPayment />}
                /> */}
                <PrivateRoute
                  exact
                  path="/paymentProcess"
                  component={(props) => <PaymentProcess />}
                />
                <PrivateRoute
                  path="/transaction-status"
                  component={(props) => <PosTransactionStatus />}
                />
                <PrivateRoute
                  path="/offline-finance-search"
                  component={(props) => <OffilneFinanceSearch />}
                />
                <PrivateRoute
                  path="/initiate-loan"
                  component={(props) => <InitiateLoan />}
                />
                <PrivateRoute
                  path="/offline-transaction-status"
                  component={(props) => <LoanSuccess />}
                />
                <Route exact path="/tnc" component={TermsConditions} />
                <Route exact path="/password" component={Password} />
                <Route exact path="/policy" component={PrivacyPolicy} />

                <Route exact path="/otp" component={OTP} />

                <Route exact path="/phoneNumber" component={PhoneNumber} />

                <PrivateRoute
                  exact
                  path="/cash-type"
                  component={(props) => <CashType />}
                />

                <PrivateRoute
                  exact
                  path="/cash-type-payments"
                  component={(props) => <CashTypePayment />}
                />

                <PrivateRoute
                  exact
                  path="/apply-coupon-search"
                  component={(props) => <ApplyCouponSearch />}
                />
                <PrivateRoute
                  exact
                  path="/offlinePayment"
                  component={(props) => <OfflinePayment />}
                />
                <PrivateRoute
                  exact
                  path="/codeOfflinePayment"
                  component={(props) => <CodeOfflinePayment/>}
                />
                <PrivateRoute
                  exact
                  path="/offlinePaymentSuccess"
                  component={(props) => <SuccessfulPayment />}
                />
                <PrivateRoute
                  exact
                  path="/apply-coupon"
                  component={(props) => <ApplyCouponDetails />}
                />

                <PrivateRoute
                  exact
                  path="/search-exchange"
                  component={(props) => <SearchExchange />}
                />
                <PrivateRoute
                  exact
                  path="/scooter-exchange-data"
                  component={(props) => <ScooterExchangeData />}
                />
                <PrivateRoute
                  exact
                  path="/scooter-exchange-edit"
                  component={(props) => <ScooterExchangeEdit />}
                />
                <PrivateRoute
                  exact
                  path="/scooter-exchange-online-edit"
                  component={(props) => <OfflineScooterExchangeEdit />}
                />
                <PrivateRoute
                  path="/upload-scooter"
                  component={(props) => <UploadScooter />}
                />

                <PrivateRoute
                  path="/check-scooter-eligibility"
                  component={(props) => <CheckScooterEligibility />}
                />

                <PrivateRoute
                  path="/check-scooter-status"
                  component={(props) => <CheckScooterStatus />}
                />

                <PrivateRoute
                  exact
                  path="/scooter-exchange-verify"
                  component={(props) => <ScooterExchangeVerify />}
                />

                {/* <Route
                exact
                path="/phoneNumber"
                render={(props) => {
                  console.log(
                    'Inside PhoneNumber condition',
                  );
                  return (
                    <PhoneNumber
                      // {...props}
                      redirect={false}
                    />
                  );
                }}
              /> */}
              </Switch>
            </LanguageProvider>
          </CustomerContextProvider>
        </LoginProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
